import React from 'react';
import {YMInitializer} from "react-yandex-metrika";
import AppNavigation from "../../navigation/appNavigation/AppNavigation";
import PageHeader from "../../navigation/header/PageHeader";
import ChatCard from "../../common/chat/ChatCard";

export default function BasePageView({
    content,
    footerSearch,
    getLinksData,
    userParams,
}) {
    return (
        <>
            <YMInitializer
                accounts={[parseInt(process.env.REACT_APP_YA_METRIKA_COUNTER)]}
                options={{
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true,
                    userParams: userParams
                }}
            />
            <AppNavigation searchFooter={footerSearch} getLinksData={getLinksData}/>
            <div className="content">
                <PageHeader/>
                {content}
                <ChatCard/>
            </div>
        </>
    );
}
